<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
    documents: Array<{ Key: string; Value: string }>
    // Client-generated documents (e.g. the Quote Illustration) that have no
    // server URL: rendered alongside the server documents but emit `generate`
    // on click instead of navigating.
    actionItems?: Array<{ key: string; label: string }>
}>()

const emit = defineEmits<{
    (e: 'generate', key: string): void
}>()

const hasItems = computed(
    () => (props.documents?.length ?? 0) > 0 || (props.actionItems?.length ?? 0) > 0
)
</script>

<template>
    <div class="card-shadow card rounded-lg overflow-hidden w-100">
        <div class="card-body p-0">
            <div class="border-bottom px-3 py-3">
                <span class="small text-uppercase text-muted font-weight-bold">Document list</span>
            </div>

            <div class="px-3 py-3">
                <ul v-if="hasItems" class="list-unstyled mb-0">
                    <li v-for="item in actionItems" :key="item.key" class="mb-2">
                        <a href="#" class="doc-link" @click.prevent="emit('generate', item.key)">{{ item.label }}</a>
                    </li>
                    <li v-for="doc in documents" :key="doc.Key" class="mb-2">
                        <a :href="doc.Value" target="_blank" rel="noopener" class="doc-link">{{ doc.Key }}</a>
                    </li>
                </ul>
                <div v-else class="small text-muted">
                    No documents available.
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.doc-link {
    color: #17a2b8;
    text-decoration: none;
}

.doc-link:hover,
.doc-link:focus {
    color: #117a8b;
    text-decoration: underline;
}
</style>
